import { useRef } from "react";
import useGetSpectrum from "./hooks/useGetSpectrum";
import SpectrumPreview from "./SpectrumPreview";
import { P2 } from "../../components/Paragraph";
import styles from "./spectrumCardHoverable.module.css";
import useLang from "../../hooks/useLang";
import useSimpleDate from "../../hooks/useSimpleDate";
import getProbabilityTag from "../../utils/getProbabilityTag";
import classNames from "classnames";
import getGroupActions from "./utils/getGroupActions";
import getConfusionActions from "./utils/getConfusionActions";
import Button from "../../components/Button";

const SpectrumCardHoverable = ({ id, showProbability = false }) => {
  const idRef = useRef(crypto.randomUUID());
  const lang = useLang();
  const { getSimpleDate } = useSimpleDate();
  const { data: originalData } = useGetSpectrum({ id });

  const data = originalData
    ? { ...originalData, probability: 0.01, groupType: "UNASSIGNED" }
    : null;
  const groupActions = getGroupActions(data?.groupType);
  const prognosisActions = getConfusionActions(
    data?.groupType,
    data?.probability
  );

  return (
    <div className={styles.spectrumCardHoverable}>
      {showProbability && typeof data?.probability === "number" ? (
        <div
          className={classNames(
            styles.probability,
            styles[getProbabilityTag(data?.probability)]
          )}
        >
          {`${lang("captions.probability")}: ${data?.probability}`}
        </div>
      ) : null}
      <SpectrumPreview data={data} viewOnly size={"small"} />
      <div>
        <P2>{`${lang("captions.date_modified")} ${getSimpleDate(
          data?.date_modified
        )}`}</P2>
      </div>
      <div className={styles.hoverContainer}>
        {showProbability && typeof data?.probability === "number" ? (
          <>
            <div
              className={classNames(
                styles.probability,
                styles[getProbabilityTag(data?.probability)]
              )}
            >
              {`${lang("captions.probability")}: ${data?.probability}`}
            </div>
          </>
        ) : null}
        <div className={styles.spacer} />
        {showProbability ? (
          <div style={{ display: "flex", gap: "var(--gap-sm)" }}>
            {Array.isArray(prognosisActions)
              ? prognosisActions?.map((action, idx) => (
                  <Button
                    key={`${idRef?.current}-${idx}`}
                    important={action?.type === "RECOMENDED"}
                    warning={action?.type === "ALERT"}
                  >
                    {lang(`captions.${action?.id}`)}
                  </Button>
                ))
              : null}
          </div>
        ) : (
          <div style={{ display: "flex", gap: "var(--gap-sm)" }}>
            {Array.isArray(groupActions)
              ? groupActions?.map((action, idx) => (
                  <Button key={`${idRef?.current}-${idx}`}>
                    {lang(`captions.${action}`)}
                  </Button>
                ))
              : null}
          </div>
        )}
        <div className={styles.spacer} />
      </div>
    </div>
  );
};

export default SpectrumCardHoverable;
